import React, { Fragment } from 'react';
import { Link } from '@zapier/design-system';

export const viewTypes = {
  DEFAULT: 'DEFAULT',
  DEFAULT_TRIGGERED_BY_ZAP: 'DEFAULT_TRIGGERED_BY_ZAP',
  TRIAL_EXTENSION: 'TRIAL_EXTENSION',
  TRIAL_EXTENSION_TRIGGERED_BY_ZAP: 'TRIAL_EXTENSION_TRIGGERED_BY_ZAP',
};

const views = {
  ['DEFAULT']: (wasTriggeredByZapToggle: boolean) =>
    wasTriggeredByZapToggle
      ? {
          bodyText: (
            <Fragment>
              To turn on your Zap, you'll need access to{' '}
              <Link
                href="/help/create/customize/add-branching-logic-to-zaps-with-paths"
                target="_blank"
              >
                Paths
              </Link>
              . Edit your Zap or upgrade now to turn on your Zap.
            </Fragment>
          ),
          type: viewTypes.DEFAULT_TRIGGERED_BY_ZAP,
        }
      : {
          bodyText: (
            <Fragment>
              With{' '}
              <Link
                href="/help/create/customize/add-branching-logic-to-zaps-with-paths"
                target="_blank"
              >
                paths
              </Link>
              , your Zap can perform different actions based on different
              conditions. Upgrade to our Professional plan to use paths.
            </Fragment>
          ),
          type: viewTypes.DEFAULT,
        },

  ['TRIAL_EXTENSION']: (wasTriggeredByZapToggle: boolean) =>
    wasTriggeredByZapToggle
      ? {
          bodyText: (
            <Fragment>
              To turn on your Zap, you'll need access to{' '}
              <Link
                href="/help/create/customize/add-branching-logic-to-zaps-with-paths"
                target="_blank"
              >
                Paths
              </Link>
              . Upgrade now or start a free 7-day trial of the Professional plan
              to use Paid Features like Paths.
            </Fragment>
          ),
          type: viewTypes.TRIAL_EXTENSION_TRIGGERED_BY_ZAP,
        }
      : {
          bodyText: (
            <Fragment>
              With{' '}
              <Link
                href="/help/create/customize/add-branching-logic-to-zaps-with-paths"
                target="_blank"
              >
                paths
              </Link>
              , your Zap can perform different actions based on different
              conditions. Upgrade now or start a free 7-day trial of our
              Professional plan to use paths.
            </Fragment>
          ),
          type: viewTypes.TRIAL_EXTENSION,
        },
};

type Props = {
  canExtendTrial: boolean;
  wasTriggeredByZapToggle: boolean;
};

export const getActiveView = ({
  canExtendTrial,
  wasTriggeredByZapToggle,
}: Props) =>
  canExtendTrial
    ? views.TRIAL_EXTENSION(wasTriggeredByZapToggle)
    : views.DEFAULT(wasTriggeredByZapToggle);
